import { Node } from 'prosemirror-to-html-js';
import get from 'lodash/get';
export default class Paragraph extends Node {
  matching () {
    return this.node.type === "paragraph";
  }

  tag () {
    return [
      {
        tag: "p",
        attrs: {
          style: this.getStyles()
        }
      }
    ]
  }

  getStyles() {
    let styles = '';
    if ( get(this.node, 'attrs.textAlign') ) {
      styles += `text-align: ${get(this.node, 'attrs.textAlign')};`
    }
    return styles;
  }
}
